import mapboxgl from 'mapbox-gl';

const layersDataUri =
  'data:image/svg+xml;base64,PHN2ZyByb2xlPSJpbWciIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGQ9Ik0xMiwxNkwxOS4zNiwxMC4yN0wyMSw5TDEyLDJMMyw5TDQuNjMsMTAuMjdNMTIsMTguNTRMNC42MiwxMi44MUwzLDE0LjA3TDEyLDIxLjA3TDIxLDE0LjA3TDE5LjM3LDEyLjhMMTIsMTguNTRaIiAvPjwvc3ZnPg==';

export const FLAT_STYLE = 'mapbox://styles/mapbox/light-v10';
export const SATELLITE_STYLE = 'mapbox://styles/mapbox/satellite-streets-v11';

/** Highlight colour for overlays that need to stand out on satellite imagery */
export const SATELLITE_HIGHLIGHT = '#ffd600';

/** Added to the map container while the satellite style is active */
export const SATELLITE_CLASS = 'map--satellite';

/**
 * Switches the map between the flat and satellite base styles.
 *
 * setStyle() removes any sources/layers added in code, so anything drawn on
 * the map should be (re)built in a 'style.load' handler. Mapbox Draw re-adds
 * its own layers on style change. DOM markers are unaffected, but can be
 * restyled via the SATELLITE_CLASS on the map container.
 */
export default class SatelliteToggleControl implements mapboxgl.IControl {
  container: HTMLElement;

  button: HTMLButtonElement;

  map: mapboxgl.Map;

  satellite: boolean;

  /** `satellite` should match the style the map was created with */
  constructor(satellite = true) {
    this.satellite = satellite;
  }

  onAdd(map: mapboxgl.Map) {
    this.map = map;

    this.button = document.createElement('button');
    this.button.classList.add('mapboxgl-ctrl-shape-import__label');
    this.button.style.backgroundImage = `url('${layersDataUri}')`;
    this.button.title = 'Toggle Satellite';
    this.button.addEventListener('click', e => {
      e.preventDefault();
      this.setSatellite(!this.satellite);
    });
    this.updateButton();

    this.container = document.createElement('div');
    this.container.classList.add('mapboxgl-ctrl-group', 'mapboxgl-ctrl');
    this.container.appendChild(this.button);
    return this.container;
  }

  onRemove() {
    const parent = this.container.parentNode;
    if (parent) {
      parent.removeChild(this.container);
    }
  }

  setSatellite(satellite: boolean) {
    this.satellite = satellite;
    this.updateButton();
    // diff: false forces a full reload so 'style.load' always fires
    this.map.setStyle(satellite ? SATELLITE_STYLE : FLAT_STYLE, {
      diff: false,
    });
  }

  updateButton() {
    this.button.classList.toggle(
      'mapboxgl-ctrl-shape-import__label--active',
      this.satellite,
    );
    this.map.getContainer().classList.toggle(SATELLITE_CLASS, this.satellite);
  }
}
